/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button } from '@mui/material';
import LegacyGrid from './legacy/LegacyGrid';
import { withStyles } from '@mui/styles';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import InputBase from '@mui/material/InputBase';
import Paper from '@mui/material/Paper';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { navigationButtonStyle } from '../common/common';
import { actionCreators } from '../store/UploadDownloads';
import './styles.css';

interface Props {
    next: any
    back: any

    classes?: any
    selectedProductModels?: any
    uploadDetails?: any
    downloadsClassificationModelCodeMapping: any

    handleDownloadModelCodeChange: Function
}
const styles = () => ({
    input: {
        height: 0,
        width: 300,
        backgroundColor: '#fff'
    },
    selectInput: {
        width: 328,
        height: 40,
        backgroundColor: '#fff'
    },
    navigationButton: navigationButtonStyle
})


class DownloadsModelCode extends React.Component<Props>{
    state = {
        downloadsClassificationModelCodeMappingState: []
    };

    componentDidMount() {
        const modelCodeMapping = [];
        const selectProductModels = [];
        for (const value in this.props.selectedProductModels) {
            const id = this.props.selectedProductModels[value];
            const productModel = this.props.uploadDetails.productModels.find(function (m: any) {
                return m.id === id;
            });
            selectProductModels.push(productModel);
        }

        for (const key in selectProductModels) {
            const modelid = selectProductModels[key]['id'];
            const modelname = selectProductModels[key]['name'];
            let obj = null;
            if (this.props.downloadsClassificationModelCodeMapping !== undefined) {
                obj = this.props.downloadsClassificationModelCodeMapping.find(function (x: any) {
                    return x.twodModelId === modelid;
                });

            }
            if (obj === undefined || obj == null) {
                obj = {
                    twodModelId: modelid,
                    value: '',
                    modelCode: []
                };
            }
            obj['name'] = modelname;

            modelCodeMapping.push(obj);
        }

        this.setState({ downloadsClassificationModelCodeMappingState: modelCodeMapping }, () => {
            this.props.handleDownloadModelCodeChange(this.state.downloadsClassificationModelCodeMappingState);
        });

    }

    addProductModel = (event: any) => {
        event.preventDefault();
        if (event !== undefined) {
            const modelCodeMapping: any[] = this.state.downloadsClassificationModelCodeMappingState;
            if (modelCodeMapping !== undefined) {
                const model = modelCodeMapping.find(function (x: any) {
                    return x.twodModelId == event.target.id;
                });
                if (model !== undefined && model !== null) {
                    const value = model.value;
                    if (value !== undefined && value != null && value.trim() !== '') {
                        modelCodeMapping.find(function (x: any) {
                            return x.twodModelId == event.target.id;
                        })!.modelCode.push(value);
                        modelCodeMapping.find(function (x: any) {
                            return x.twodModelId == event.target.id;
                        })!.value = '';
                        this.setState({ downloadsClassificationModelCodeMappingState: modelCodeMapping }, () => {
                            this.props.handleDownloadModelCodeChange(this.state.downloadsClassificationModelCodeMappingState);
                        });
                    }
                }
            }
        }

    };

    onChange = (event: any) => {
        const modelCodeMapping: any[] = this.state.downloadsClassificationModelCodeMappingState;
        const value = modelCodeMapping.find(function (x: any) {
            return x.twodModelId == event.target.id;
        });
        if (value !== undefined) {
            modelCodeMapping.find(function (x: any) {
                return x.twodModelId == event.target.id;
            })!.value = event.target.value;
            this.setState({ downloadsClassificationModelCodeMappingState: modelCodeMapping }, () => {
                this.props.handleDownloadModelCodeChange(this.state.downloadsClassificationModelCodeMappingState);
            });
        }
    };

    handleRemoveFilter = (id: any, index: any) => {
        if (id !== undefined) {
            const modelCodeMapping: any[] = this.state.downloadsClassificationModelCodeMappingState;
            if (modelCodeMapping !== undefined) {
                if (index !== undefined) {
                    modelCodeMapping.find(function (x: any) {
                        return x.twodModelId == id;
                    })!.modelCode!.splice(index, 1);
                    this.setState({ downloadsClassificationModelCodeMappingState: modelCodeMapping }, () => {
                        this.props.handleDownloadModelCodeChange(this.state.downloadsClassificationModelCodeMappingState);
                    });
                }
            }
        }
    };

    render() {
        const { classes } = this.props;
        let title = '';
        title = '3. Fill the model code for selected product models';

        return (
            <LegacyGrid className="classificationGrid" >
                <LegacyGrid className="downloadModelCodeGridTitle">{title}</LegacyGrid>
                <LegacyGrid className="downloadModelCodeGridDescription">Model code is used only by a small set of optical products.
                    For all other product models: Proceed to Next without datafilling the field(s).
                </LegacyGrid>

                <LegacyGrid style={{ height: '80%', overflow: 'auto' }}>
                    <LegacyGrid className="classificationGridContents" >
                        {
                            this.state.downloadsClassificationModelCodeMappingState.map((x: any) => (
                                <LegacyGrid key={x.twodModelId}>
                                    <LegacyGrid container className="manualInformationContent">
                                        <LegacyGrid item xs={4}>{x.name}</LegacyGrid>
                                        <LegacyGrid item xs={8}>
                                            <Paper component="form" sx={{ display: 'flex', alignItems: 'center', height: '45px' }}>
                                                <InputBase
                                                    key={x.twodModelId}
                                                    id={x.twodModelId}
                                                    name={x.name}
                                                    sx={{ ml: 1, flex: 1 }}
                                                    value={x.value}
                                                    onChange={(inputUser) => this.onChange(inputUser)}
                                                    onKeyPress={(e) => { e.key === 'Enter' && this.addProductModel(e); }}
                                                />
                                                <IconButton key={x.twodModelId} id={x.twodModelId} value={x.value} onClick={(x) => this.addProductModel(x)}>
                                                    <AddIcon id={x.twodModelId} />
                                                </IconButton>
                                            </Paper>
                                        </LegacyGrid>
                                    </LegacyGrid>
                                    <LegacyGrid container className="manualInformationContent" justifyContent="flex-end">
                                        <LegacyGrid item xs={8} className="dropDownChipHolderDownloads" >
                                            {(x.modelCode.map((value: any, index: any) => (
                                                <Chip className="dropdownChips" label={value} onDelete={() => this.handleRemoveFilter(x.twodModelId, index)} />
                                            )))
                                            }
                                        </LegacyGrid>
                                    </LegacyGrid>
                                </LegacyGrid>
                            ))
                        }
                    </LegacyGrid>
                </LegacyGrid>

                <LegacyGrid container justifyContent="flex-end" >
                    <Button className={classes.navigationButton} onClick={this.props.back} >Previous</Button>
                    <Button className={classes.navigationButton} onClick={this.props.next} >Next</Button>

                </LegacyGrid>
            </LegacyGrid>

        );
    }
}
const mapStateToProps = (state: any) => ({
    selectedProductModels: state.uploadDownloads.selectedProductModels,
    uploadDetails: state.uploadDownloads.uploadDetails,
    downloadsClassificationModelCodeMapping: state.uploadDownloads.downloadsClassificationModelCodeMapping
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)
    (withStyles(styles)(DownloadsModelCode));
